import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import {
  FormArray,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { InputComponent } from 'src/app/components/shared/input';
import { CategoryService } from 'src/app/services/category';
import { LocaleService } from 'src/app/services/locale';
import { DropdownComponent } from '../../../../shared/dropdown';
import { TrashComponent } from '../../../../icons/trash';
import { PlusComponent } from '../../../../icons/plus';

@Component({
  selector: 'app-category3-question4',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputComponent,
    DropdownComponent,
    TrashComponent,
    PlusComponent
  ],
  template: `
    <div>
      <div class="flex justify-between mb-4 items-center">
        <div class="text-[13px]">
          {{ strings[language].question }}
        </div>
        <div (click)="addRow()">
          <button
            class="bg-[#F8F9FA] px-3 py-2 rounded text-white text-md cursor-pointer"
          >
            <app-plus></app-plus>
          </button>
        </div>
      </div>

      <div class="space-y-4">
        <div
          *ngFor="let row of rows.controls; let i = index"
          class="border rounded-lg p-4"
        >
          <div class="flex justify-end mb-4 cursor-pointer">
            <div
              (click)="removeRow(i)"
              class="w-1/12 flex justify-end pr-3 align-middle items-center cursor-pointer"
            >
              <app-trash></app-trash>
            </div>
          </div>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <div class="flex items-center mb-1">
                <label class="block text-sm font-medium">{{
                  strings[language].label_1
                }}</label>
                <div class="relative group ml-2 mt-0.5">
                  <button
                    type="button"
                    class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="$event.stopPropagation()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </button>
                  <div
                    class="absolute z-10 hidden group-hover:block w-48 bg-white p-2 border border-gray-200 rounded shadow-lg text-sm left-0 bottom-full mb-2"
                  >
                    {{ transportLables[language].label_1 }}
                  </div>
                </div>
              </div>
              <app-input
                type=""
                placeholder="{{ strings[language].label_1 }}"
                [control]="getControl(row, 'visitorGroup')"
              ></app-input>
            </div>

            <div>
              <div class="flex items-center mb-1">
                <label class="block text-sm font-medium">{{
                  strings[language].label_2
                }}</label>
                <div class="relative group ml-2 mt-0.5">
                  <button
                    type="button"
                    class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="$event.stopPropagation()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </button>
                  <div
                    class="absolute z-10 hidden group-hover:block w-32 bg-white p-2 border border-gray-200 rounded shadow-lg text-sm left-0 bottom-full mb-2"
                  >
                    {{ transportLables[language].label_2 }}
                  </div>
                </div>
              </div>
              <app-input
                type=""
                placeholder="{{ strings[language].label_2 }}"
                [control]="getControl(row, 'departure')"
              ></app-input>
            </div>

            <div>
              <div class="flex items-center mb-1">
                <label class="block text-sm font-medium">{{
                  strings[language].label_3
                }}</label>
              </div>
              <app-input
                type=""
                placeholder="{{ strings[language].label_3 }}"
                [control]="getControl(row, 'destination')"
              ></app-input>
            </div>

            <div>
              <div class="flex items-center mb-1">
                <label class="block text-sm font-medium">{{
                  strings[language].label_4
                }}</label>
                <div class="relative group ml-2 mt-0.5">
                  <button
                    type="button"
                    class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="$event.stopPropagation()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </button>
                  <div
                    class="absolute z-10 hidden group-hover:block w-32 bg-white p-2 border border-gray-200 rounded shadow-lg text-sm left-0 bottom-full mb-2"
                  >
                    {{ transportLables[language].label_4 }}
                  </div>
                </div>
              </div>
              <app-dropdown
                placeholder="{{ strings[language].select }} {{
                  strings[language].label_4
                }}"
                [options]="transportOptions"
                [control]="getControl(row, 'transportMode')"
              ></app-dropdown>
            </div>

            <div>
              <div class="flex gap-6">
                <div class="flex items-center mb-1">
                  <label class="block text-sm font-medium">{{
                    strings[language].label_5
                  }}</label>
                  <div class="relative group ml-2 mt-0.5">
                    <button
                      type="button"
                      class="text-gray-500 hover:text-gray-700 focus:outline-none"
                      (click)="$event.stopPropagation()"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="h-4 w-4"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                    </button>
                    <div
                      class="absolute z-10 hidden group-hover:block w-52 bg-white p-2 border border-gray-200 rounded shadow-lg text-sm left-0 bottom-full mb-2"
                    >
                      {{ transportLables[language].label_5 }}
                    </div>
                  </div>
                </div>

                <div class="flex 4 mb-2">
                  <div
                    (click)="setFrequencyType(row, 'month')"
                    class="flex gap-2 align-middle items-center cursor-pointer text-[13px]"
                  >
                    <div
                      [ngClass]="{
                        'bg-[#183A25]':
                          getControl(row, 'frequencyType').value === 'month'
                      }"
                      class="w-4 h-4 border border-gray-500 rounded-full flex-shrink-0"
                    ></div>
                    <div>{{ strings[language].month }}</div>
                  </div>
                  <div
                    (click)="setFrequencyType(row, 'quarter')"
                    class="flex gap-2 ml-2 align-middle items-center cursor-pointer text-[13px]"
                  >
                    <div
                      [ngClass]="{
                        'bg-[#183A25]':
                          getControl(row, 'frequencyType').value === 'quarter'
                      }"
                      class="w-4 h-4 border border-gray-500 rounded-full flex-shrink-0"
                    ></div>
                    <div>{{ strings[language].quarter }}</div>
                  </div>
                </div>
              </div>

              <app-input
                type="number"
                placeholder="{{ strings[language].label_5 }}"
                [control]="getControl(row, 'frequency')"
              ></app-input>
            </div>
            <div>
              <div class="flex items-center mb-1">
                <label class="block text-sm font-medium">{{
                  strings[language].label_6
                }}</label>
                <div class="relative group ml-2 mt-0.5">
                  <button
                    type="button"
                    class="text-gray-500 hover:text-gray-700 focus:outline-none"
                    (click)="$event.stopPropagation()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      />
                    </svg>
                  </button>
                  <div
                    class="absolute z-10 hidden group-hover:block w-64 bg-white p-2 border border-gray-200 rounded shadow-lg text-sm left-0 bottom-full mb-2"
                  >
                    {{ transportLables[language].label_6 }}
                  </div>
                </div>
              </div>
              <app-input
                type=""
                placeholder="{{ strings[language].label_6 }}"
                [control]="getControl(row, 'reductionMeasures')"
              ></app-input>
            </div>
          </div>
        </div>
      </div>
    </div>
  `
})
export class Category3Question4Component {
  language = inject(LocaleService).getLanguage();
  categoryService = inject(CategoryService);
  categories = this.categoryService.categories();

  form = new FormGroup({
    rows: new FormArray<FormGroup>([])
  });

  get rows() {
    return this.form.get('rows') as FormArray<FormGroup>;
  }
  transportLables: any = {
    english: {
      label_1: 'Clients, Partners, Auditors',
      label_2: 'Milan, Brussels',
      label_3: 'Milan, Brussels',
      label_4: 'Flight, Train, Car',
      label_5: '2 visits/month, 1 visit/quarter',
      label_6: 'virtual meetings, limited on-site visits, carbon offsets'
    },
    italian: {
      label_1: 'Clienti, Partner, Revisori',
      label_2: 'Milano, Bruxelles',
      label_3: 'Milano, Bruxelles',
      label_4: 'Aereo, Treno, Auto',
      label_5: '2 visite/mese, 1 visita/trimestre',
      label_6:
        'riunioni virtuali, visite in loco limitate, compensazione delle emissioni'
    }
  };

  // Helper method to safely get controls with proper typing
  getControl(row: FormGroup, controlName: string): FormControl {
    const control = row.get(controlName);
    if (!(control instanceof FormControl)) {
      throw new Error(`Control ${controlName} not found or not a FormControl`);
    }
    return control;
  }

  strings: any = {
    english: {
      quarter: 'quarter',
      month: 'month',
      question: 'Visitor Travel to Office',
      label_1: 'Visitor Group',
      label_2: 'Departure',
      label_3: 'Destination',
      label_4: 'Transport Mode',
      label_5: 'Frequency',
      label_6: 'Travel Reduction Measures',
      select: 'Select'
    },
    italian: {
      quarter: 'trimestre',
      month: 'mese',
      question: "Viaggi dei Visitatori verso l'Ufficio",
      label_1: 'Gruppo di Visitatori',
      label_2: 'Partenza',
      label_3: 'Destinazione',
      label_4: 'Mezzo di Trasporto',
      label_5: 'Frequenza',
      label_6: 'Misure di Riduzione dei Viaggi',
      select: 'Seleziona'
    }
  };

  ngOnInit() {
    const categories = localStorage.getItem('categories');
    if (categories) {
      const parsed = JSON.parse(categories);
      const answers = parsed[2]?.questions[3]?.answers;

      if (answers?.length > 0) {
        answers.forEach((entry: any) => {
          // Ensure no shared object reference
          const cleanEntry = JSON.parse(JSON.stringify(entry));
          this.addRow(cleanEntry);
        });
      } else {
        this.addRow();
      }
    } else {
      this.addRow();
    }

    this.form.valueChanges.subscribe(() => this.saveForm());
  }

  transportOptionsRaw = [
    { value: 'flight', label: 'Flight', labelIt: 'Aereo' },
    { value: 'train', label: 'Train', labelIt: 'Treno' },
    { value: 'car', label: 'Car', labelIt: 'Macchina' }
  ];

  transportOptions = this.transportOptionsRaw.map(option => ({
    value: option.value,
    label: this.language === 'english' ? option.label : option.labelIt
  }));

  createRow(data: any = {}): FormGroup {
    return new FormGroup({
      visitorGroup: new FormControl(
        data.visitorGroup || '',
        Validators.required
      ),
      departure: new FormControl(data.departure || '', Validators.required),
      destination: new FormControl(data.destination || '', Validators.required),
      transportMode: new FormControl(
        data.transportMode || '',
        Validators.required
      ),

      frequency: new FormControl(data.frequency || '', Validators.required),
      frequencyType: new FormControl(data.frequencyType || 'month'),
      reductionMeasures: new FormControl(data.reductionMeasures || '')
    });
  }
  setFrequencyType(row: FormGroup, type: 'month' | 'quarter') {
    row.get('frequencyType')?.setValue(type);
  }
  addRow(data?: any) {
    this.rows.push(this.createRow(data));
  }

  removeRow(index: number) {
    this.rows.removeAt(index);
    this.saveForm();
  }

  saveForm() {
    const newAnswers = this.rows.value.map((row: any) => {
      const selectedTransport = this.transportOptionsRaw.find(
        opt => opt.value === row.transportMode?.value
      );

      return {
        ...row,
        transportMode: selectedTransport || row.transportMode
      };
    });

    this.categories[2].questions[3].answers = newAnswers as any;
    this.categoryService.persistCategories(this.categories);
  }
}
